// OneSignalProvider.js
import React, { PropsWithChildren, useEffect } from 'react';
import OneSignal from 'react-onesignal';

const OneSignalProvider: React.FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID || '',
      allowLocalhostAsSecureOrigin: true,
      autoResubscribe: true,
      autoRegister: true,
    });
    // OneSignal.Notifications.addEventListener(
    //   'foregroundWillDisplay',
    //   (event) => {
    //     console.log('The notification will display!', event);
    //   }
    // );
  }, []);

  return <>{children}</>;
};

export default OneSignalProvider;
